module.exports = __webpack_public_path__ + "img/product-shansuan-zy-01.12208a49.png";